import { Database } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const VolumeIcon = DeckardIconWrapper({ Icon: Database });
